<template>
  <CRow :gutters="false" alignHorizontal="between" class="tablesBalance">
    <CCol>
      <CRow :gutters="false" v-for="(itemBalance, index) in balance" :key="`itemBalance-${index}`">
        <TablesBalance v-if="itemBalance.channel == channel" :balance="itemBalance" class="tablesBalance__item" />
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
import TablesBalance from './TablesBalance.vue'

export default {
  name: 'WrapperTablesBalance',
  components: {
    TablesBalance,
  },

  props: {
    channel: {
      type: String,
      default: null,
    },
  },

  data() {
    return {}
  },

  computed: {
    balance() {
      return this.$store.getters['backOffice/balance']
    },
  },
}
</script>

<style lang="scss" scope>
.tablesBalance {
}
</style>
